import { useEffect } from 'react';
import { Locale } from '../types';
import { translate } from './translations';

const APP_ROUTE_TITLES: Record<string, string> = {
  '/': 'Live map',
  '/messages': 'Direct Messages',
  '/profile': 'Profile',
  '/notifications': 'Notifications',
  '/favorites': 'Favorites',
  '/my-statuses': 'My Statuses',
  '/settings': 'Settings',
  '/my-location': 'My Location',
  '/pulse': 'Map pulse',
  '/nearby-statuses': 'Nearby Statuses',
  '/hashtags': 'Hashtag explorer',
  '/about': 'About mapbl',
};

export type MapTitleState = {
  activeRoute: string;
  locationLabel?: string;
  showCreateStatus?: boolean;
  showNearbyStatuses?: boolean;
  selectionType?: 'status' | 'user';
  showMapItems?: boolean;
  showMapActions?: boolean;
};

export const formatDocumentTitle = (title: string, locale: Locale): string =>
  `${translate(title, locale)} | mapbl`;

export const getMapDocumentTitle = (state: MapTitleState, locale: Locale): string => {
  let title = APP_ROUTE_TITLES[state.activeRoute] || 'Live map';

  if (state.showMapActions) title = 'Map actions';
  if (state.showMapItems) title = 'Map items';
  if (state.selectionType === 'user') title = 'User details';
  if (state.selectionType === 'status') title = 'Status details';
  if (state.showNearbyStatuses) title = 'Nearby Statuses';
  if (state.showCreateStatus) title = 'Create Status';

  const localizedTitle = translate(title, locale);
  const locationPrefix = state.activeRoute === '/' && !state.showCreateStatus && !state.showNearbyStatuses
    && !state.selectionType && !state.showMapItems && !state.showMapActions && state.locationLabel
    ? `${state.locationLabel} — `
    : '';

  return `${locationPrefix}${localizedTitle} | mapbl`;
};

export const useDocumentTitle = (title: string | null) => {
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);
};
